import React from "react";
import { Fade } from "react-awesome-reveal";
import Copyright from "./Copyright";
import { FiMail, FiMapPin, FiPhone } from "react-icons/fi";
import {
  PHONE_MOBILE_DISPLAY,
  PHONE_OFFICE_DISPLAY,
  PHONE_MOBILE_HREF,
  PHONE_OFFICE_HREF,
} from "../../../constants/contact";

interface FooterProps {
  variant?: string;
}

const Footer: React.FC<FooterProps> = ({ variant }) => {
  const mapUrl =
    "https://www.google.com/maps?q=Unit%201502-%20239%20Queen%20St%20E%2C%20Brampton%2C%20ON%20L6W%202B6";
  const renderAbout = () => (
    <Fade triggerOnce>
      <div>
        <a href="/" className="flex items-center gap-3 mb-4">
          <img src="/images/logo2.png" alt="Logo" className={`${variant === "light" ? "w-16" : "w-16 invert brightness-0"}`} />
          <div>
            <p
              className={`${
                variant === "light" ? "text-red-700" : "text-white"
              } text-2xl font-bold`}
            >
              ALPHA
            </p>
            <p
              className={`${
                variant === "light" ? "text-red-700" : "text-white"
              } text-md font-semibold mb-0`}
            >
              MORTGAGES
            </p>
            <p
              className={`${
                variant === "light" ? "text-red-700" : "text-white"
              } text-sm font-medium px-2 py-1 rounded-md`}
              style={{ display: "inline-block"}}
            >
              FSRA#13820
            </p>
          </div>
        </a>
      </div>
    </Fade>
  );

  const renderQuickLinks = () => (
    <Fade delay={200} triggerOnce>
      <div className="pl-0 lg:pl-10">
        <h3 className="text-lg mb-4">Quick Links</h3>
        <ul>
          <li className="mb-2">
            <a
              href="/about"
              className={`${
                variant === "light"
                  ? "text-gray-600 hover:text-black"
                  : "text-gray-300 hover:text-white"
              }`}
            >
              About
            </a>
          </li>
          <li className="mb-2">
            <a
              href="/news"
              className={`${
                variant === "light"
                  ? "text-gray-600 hover:text-black"
                  : "text-gray-300 hover:text-white"
              }`}
            >
              News
            </a>
          </li>
          <li className="mb-2">
            <a
              href="/blogs"
              className={`${
                variant === "light"
                  ? "text-gray-600 hover:text-black"
                  : "text-gray-300 hover:text-white"
              }`}
            >
              Blogs
            </a>
          </li>
          <li className="mb-2">
            <a
              href="/contact"
              className={`${
                variant === "light"
                  ? "text-gray-600 hover:text-black"
                  : "text-gray-300 hover:text-white"
              }`}
            >
              Contact Us
            </a>
          </li>
        </ul>
      </div>
    </Fade>
  );

  const renderContactUs = () => (
    <Fade delay={400} triggerOnce>
      <div>
        <h3 className="text-lg mb-4">Contact Us</h3>
        <div className="flex items-center gap-3 mb-4">
          <div className="flex items-center">
            <FiMapPin size={20} className={`${variant === "light" ? 'text-cred-100' : "text-white"}`} />
          </div>
          <a
            href={mapUrl}
            target="_blank"
            rel="noreferrer"
            className={`${
              variant === "light"
                ? "text-gray-600 hover:text-black"
                : "text-gray-300 hover:text-white"
            } underline-offset-4 hover:underline`}
          >
            Unit 1502- 239 Queen St E, Brampton, ON L6W 2B6
          </a>
        </div>
        <div className="flex flex-col gap-2 mb-4">
          <a
            href={PHONE_MOBILE_HREF}
            className={`flex flex-wrap items-center gap-2 ${
              variant === "light"
                ? "text-gray-600 hover:text-black"
                : "text-gray-300 hover:text-white"
            }`}
          >
            <FiPhone
              size={20}
              className={`${
                variant === "light" ? "text-cred-100" : "text-white"
              } shrink-0`}
            />
            <span className="text-xs uppercase opacity-80">Mobile</span>
            <span>{PHONE_MOBILE_DISPLAY}</span>
          </a>
          <a
            href={PHONE_OFFICE_HREF}
            className={`flex flex-wrap items-center gap-2 ${
              variant === "light"
                ? "text-gray-600 hover:text-black"
                : "text-gray-300 hover:text-white"
            }`}
          >
            <FiPhone
              size={20}
              className={`${
                variant === "light" ? "text-cred-100" : "text-white"
              } shrink-0`}
            />
            <span className="text-xs uppercase opacity-80">Office</span>
            <span>{PHONE_OFFICE_DISPLAY}</span>
          </a>
        </div>
        <div className="flex items-center gap-3">
          <a
            href="mailto:info@alpham.ca"
            className={`flex gap-2 items-center ${
              variant === "light"
                ? "text-gray-600 hover:text-black"
                : "text-gray-300 hover:text-white"
            }`}
          >
            <FiMail size={20} className={`${
                variant === "light" ? "text-cred-100" : "text-white"
            } shrink-0`} />
            <span>info@alpham.ca</span>
          </a>
        </div>
      </div>
    </Fade>
  );

  const renderCopyright = () => (
    <Fade triggerOnce>
      <Copyright variant={variant} />
    </Fade>
  );

  return (
    <footer
      // className={`${variant === "light" ? "" : "bg-neutral-900 text-white"}`}
      className={`${variant === "light" ? "" : "bg-cred-200 text-white"}`}
    >
      <div className="container mx-auto px-6 py-10 ">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {renderAbout()}
          {renderQuickLinks()}
          {renderContactUs()}
        </div>
        {renderCopyright()}
      </div>
    </footer>
  );
};

export default Footer;
